/* eslint-disable no-console */
import React from 'react';
import { Col, Row, Label, CardBody } from 'reactstrap';
import { api } from '../../../config';

import { convertToDisplayDateFormatddmmmyyyy } from '../../../utils/dateformatter';
import { useState, useEffect } from 'react';
import ActionButton from '../../../Components/Common/ActionButton';

const IncotermTableFragment = ({ dataid, token, onViewOrigin }) => {
  const [qtyDeliveryDataIncoterm, setQtyDeliveryDataIncoterm] = useState({
    items: [],
  });

  useEffect(() => {
    const fetchDeliveryDataDetailIncoterm = async dataid => {
      try {
        const response = await fetch(
          `${api.API_URL}/quantity-incoterm?QuantityDeliveryTermId=${dataid}`,
          {
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${token}`,
            },
          }
        );
        const result = await response.json();
        const items = result.data.items.map(item => ({
          incoterm: item.incoterm?.name ?? null,
          incotermPortType: item.incotermPortType,
          incotermLocation: item.incotermLocation?.location?.name ?? null,
          startDate:
            convertToDisplayDateFormatddmmmyyyy(item.startDate) ?? null,
          endDate: convertToDisplayDateFormatddmmmyyyy(item.endDate) ?? null,
          incotermLocation2: item.incotermLocation2?.location?.name ?? null,
          startDate2:
            convertToDisplayDateFormatddmmmyyyy(item.startDate2) ?? null,
          endDate2: convertToDisplayDateFormatddmmmyyyy(item.endDate2) ?? null,
          incotermLocation3: item.incotermLocation3?.location?.name ?? null,
          startDate3:
            convertToDisplayDateFormatddmmmyyyy(item.startDate3) ?? null,
          endDate3: convertToDisplayDateFormatddmmmyyyy(item.endDate3) ?? null,
          timelineType: item.timelineType,
          incotermFOBLocations: Array.isArray(item?.incotermFOBLocations)
            ? item.incotermFOBLocations
            : item?.incotermFOBLocations
              ? [item.incotermFOBLocations]
              : null,
          routes: item.incotermRoute?.name ?? null,
        }));
        setQtyDeliveryDataIncoterm({ items });
      } catch (error) {
        console.error('Error:', error);
      }
    };

    fetchDeliveryDataDetailIncoterm(dataid);
  }, [dataid, token]);

  return (
    <Col lg={7}>
      <Label for='incotermreadonly' className='form-label'>
        Incoterm
      </Label>
      <Row>
        <Col sm={12}>
          <div className='mb-2'>
            <CardBody>
              <div className='table-card overflow-x-auto'>
                <table className='table table-hover table-centered align-middle table-nowrap '>
                  <thead className='table-light'>
                    <tr>
                      <th scope='col' width='80%' className='py-2'>
                        Delivery
                      </th>
                      <th scope='col' width='10%' className='py-2'>
                        <span className='visually-hidden'>Actions</span>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {qtyDeliveryDataIncoterm.items.map((data, index) => (
                      <tr key={`${data.id}-${index}`}>
                        <td className='py-1'>
                          {(() => {
                            const portLocations = [];

                            if (
                              Array.isArray(data.incotermFOBLocations) &&
                              data.incotermFOBLocations.length > 0
                            ) {
                              const names = data.incotermFOBLocations
                                .map(loc => loc.name)
                                .join(' or ');
                              portLocations.push({
                                location: `${data.routes} ${names}`,
                                startDate: data.startDate,
                                endDate: data.endDate,
                              });
                            }

                            if (
                              data.incotermLocation != null &&
                              data.incotermLocation !== ''
                            ) {
                              portLocations.push({
                                location: data.incotermLocation,
                                startDate: data.startDate,
                                endDate: data.endDate,
                              });
                            }
                            if (
                              data.incotermLocation2 != null &&
                              data.incotermLocation2 !== ''
                            ) {
                              portLocations.push({
                                location: data.incotermLocation2,
                                startDate: data.startDate2,
                                endDate: data.endDate2,
                              });
                            }
                            if (
                              data.incotermLocation3 != null &&
                              data.incotermLocation3 !== ''
                            ) {
                              portLocations.push({
                                location: data.incotermLocation3,
                                startDate: data.startDate3,
                                endDate: data.endDate3,
                              });
                            }
                            return portLocations.map((item, idx) => (
                              <p
                                className='mb-1'
                                key={idx}
                                style={{
                                  whiteSpace: 'pre-wrap',
                                  wordBreak: 'break-word',
                                }}
                              >
                                {data.incoterm} {data.incotermPortType}{' '}
                                {data.incoterm === 'FOB' &&
                                Array.isArray(data.incotermFOBLocations) &&
                                data.incotermFOBLocations.length > 3
                                  ? `${data.routes} all ${data.routes}`
                                  : item.location}
                                ,{' on '}
                                {data.timelineType} {item.startDate} -{' '}
                                {item.endDate}
                              </p>
                            ));
                          })()}
                        </td>
                        <td>
                          {Array.isArray(data.incotermFOBLocations) &&
                            data.incotermFOBLocations.length > 3 && (
                              <ActionButton
                                variant='tertiary'
                                className='p-0'
                                onClick={() =>
                                  onViewOrigin(
                                    data.incotermFOBLocations,
                                    data.routes
                                  )
                                }
                              >{`View ${data.routes}`}</ActionButton>
                            )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </CardBody>
          </div>
        </Col>
      </Row>
    </Col>
  );
};

export default IncotermTableFragment;
